<template>
  <a-card :bordered="false">
试题管理（暂时为空）
  </a-card>
</template>

<script>
export default {
  name: 'zTest'
}
</script>

<style scoped>

</style>